<script>
/**
 * OwalListSection.vue
 *
 * @description A section in the list.
 *
 * @prop {String} title A string to display in the section's header.
 * @prop {Array=[]} items The items to show in the section.
 *
 */

import OwalListRow from './OwalListRow'
import OwalListSectionHeader from './OwalListSectionHeader'
import { OwalTransitionDropFade } from '../../../transitions'

export default {
  name: 'OwalListSection',
  components: {
    OwalListSectionHeader,
    OwalListRow,
    OwalTransitionDropFade,
  },
  props: {
    title: {
      type: String,
    },
    showHeader: {
      type: Boolean,
      default () {
        return !!this.title
      },
    },
    items: {
      type: Array,
      default: () => [],
    },
    initiallyCollapsed: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      collapsed: this.initiallyCollapsed,
    }
  },
  computed: {
    visibleItems () {
      return this.collapsed ? [] : this.items
    },
  },
}
</script>

<template>
  <div
    class="owal-list-section__container"
  >
    <owal-list-section-header
      v-if="this.title"
      :title="title"
      @click="collapsed = !collapsed"
    />
    <span
      v-for="item in this.visibleItems"
      :key="item.identifier"
    >
      <slot
        v-bind="item"
      >
        <owal-transition-drop-fade
          appear
        >
          <owal-list-row
            :item="item"
            class="owal-list__row-instance"
          />
        </owal-transition-drop-fade>
      </slot>
    </span>
  </div>
</template>

<style scoped>

</style>
